import { useTranslation } from 'react-i18next'
import type { MFAFactor } from '../../lib/mfa'

/** The name of a factor in the picker and the Security tab. */
export function useFactorName() {
    const { t } = useTranslation('auth')
    return (f: Pick<MFAFactor, 'kind' | 'destination'>) => {
        const kind = t(`mfa.factor_kinds.${f.kind}`)
        return f.destination ? `${kind} · ${f.destination}` : kind
    }
}

